import { lazy } from 'react';
import { createBrowserRouter } from 'react-router';
import { AppShell } from './shell/AppShell';
import { HomeScreen } from '@/features/home/HomeScreen';

/**
 * Home is bundled with the shell because it is always the first thing shown,
 * and code splitting the first screen only delays it. Everything else is
 * loaded on demand, so the launch bundle stays small.
 */
const SettingsScreen = lazy(async () => ({
  default: (await import('@/features/settings/SettingsScreen')).SettingsScreen,
}));

const PrivateScreen = lazy(async () => ({
  default: (await import('@/features/private/PrivateScreen')).PrivateScreen,
}));

const LibraryScreen = lazy(async () => ({
  default: (await import('@/features/library/LibraryScreen')).LibraryScreen,
}));

const TogetherScreen = lazy(async () => ({
  default: (await import('@/features/together/TogetherScreen')).TogetherScreen,
}));

const BrowseScreen = lazy(async () => ({
  default: (await import('@/features/browse/BrowseScreen')).BrowseScreen,
}));

const PlayerScreen = lazy(async () => ({
  default: (await import('@/features/player/PlayerScreen')).PlayerScreen,
}));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <HomeScreen /> },
      { path: 'browse', element: <BrowseScreen /> },
      { path: 'library', element: <LibraryScreen /> },
      { path: 'watch', element: <PlayerScreen /> },
      { path: 'together', element: <TogetherScreen /> },
      { path: 'private', element: <PrivateScreen /> },
      { path: 'settings', element: <SettingsScreen /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

function NotFound() {
  return (
    <div className="flex h-full items-center justify-center px-8">
      <div className="text-center">
        <p className="text-[0.9375rem] font-medium text-text-1">That screen does not exist yet</p>
        <p className="mt-1.5 text-[0.8125rem] text-text-3">
          It is on the way in a later phase of the build.
        </p>
      </div>
    </div>
  );
}
